const DEFAULT_BEHAVIOR: ScrollIntoViewOptions = { behavior: "smooth", block: "start" };

export function scrollElementIntoViewById(elementId: string, options?: ScrollIntoViewOptions) {
  const el = typeof document !== "undefined" ? document.getElementById(elementId) : null;
  if (!el) return false;
  el.scrollIntoView(options ?? DEFAULT_BEHAVIOR);
  return true;
}

export function focusFirstSelectInForm(formId: string) {
  const form = typeof document !== "undefined" ? document.getElementById(formId) : null;
  if (!form || !(form instanceof HTMLFormElement)) return false;
  const sel = form.querySelector("select");
  if (sel instanceof HTMLSelectElement) {
    sel.focus();
    return true;
  }
  return false;
}
